import { api } from '@/lib/api';

export type EditorSharedContentType = 'eduflow' | 'podcast';

export interface EditorInstitutionOption {
  id: string;
  name: string;
  email: string;
  subdomain: string | null;
  logo: string | null;
}

export interface EditorInstitutionShareRow {
  id: string;
  institutionId: string;
  institutionName: string;
  institutionEmail: string;
  subdomain: string | null;
  logo: string | null;
  sharedAt: string;
}

export interface EditorDashboardPayload {
  kpis: {
    totalFlows: number;
    podcasts: number;
    institutionShares: number;
  };
  recentActivity: Array<{
    id: string;
    kind: 'eduflow' | 'podcast';
    title: string;
    status: string;
    updatedAt: string;
  }>;
}

async function unwrap<T>(path: string, params?: Record<string, unknown>): Promise<T> {
  const res = await api.get<{ success: boolean; data: T }>(path, params);
  return res.data as T;
}

export const editorApi = {
  getDashboard: () => unwrap<EditorDashboardPayload>('/editor/dashboard'),

  searchInstitutions: (search?: string) =>
    unwrap<EditorInstitutionOption[]>('/editor/institutions', search ? { search } : undefined),

  listShares: (contentType: EditorSharedContentType, contentId: string) =>
    unwrap<EditorInstitutionShareRow[]>('/editor/shares', { contentType, contentId }),

  replaceShares: async (
    contentType: EditorSharedContentType,
    contentId: string,
    institutionIds: string[],
  ) => {
    const res = await api.put<{ success: boolean; data: EditorInstitutionShareRow[] }>('/editor/shares', {
      contentType,
      contentId,
      institutionIds,
    });
    return res.data;
  },
};

export interface InstitutionEditorShareItem {
  shareId: string;
  contentType: EditorSharedContentType;
  contentId: string;
  sharedAt: string;
  editor: { name: string; email: string; company: string | null };
  content: {
    id: string;
    title: string;
    status?: string;
    coverImageUrl?: string | null;
    updatedAt: string;
  };
}

export async function listInstitutionEditorShares(): Promise<InstitutionEditorShareItem[]> {
  const res = await api.get<{ success: boolean; data: InstitutionEditorShareItem[] }>(
    '/institution/content/editor-shares',
  );
  return res.data ?? [];
}

/** Formations éditeur partagées avec l’établissement du formateur connecté (onglet liste EduFlow). */
export async function listTrainerEditorSharedEduflows(): Promise<InstitutionEditorShareItem[]> {
  const res = await api.get<{ success: boolean; data: InstitutionEditorShareItem[] }>('/eduflows/editor-shares');
  return res.data ?? [];
}
